import { getApiVersion, http } from '../utils/domain'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}`
}

// const getMock = (appId) => {
//   return `http://127.0.0.1:9999/apps/${appId}`
// }

// 可以通过参数控制返回，orgId 返回指定组织的用户列表，appId返回指定应用的用户列表，orgGroupId返回这一组组织的用户列表
export const fetchUserList = (appId, orgId) => {
  return http()
    .get(`${prefix(appId)}/users${orgId ? `?orgId=${orgId}` : ''}`)
    .json()
}

// 获取用户轨迹
export const fetchFootPrinter = (appId, { userId, ...otherParams }) => {
  const params = {
    user_id: userId,
    app_id: appId,
    ...otherParams,
  }

  return http()
    .post(`${prefix(appId)}/footprinter/query`, params)
    .json()
}

export const fetchMultiFootPrinter = (appId, { userId, ...otherParams }) => {
  const params = {
    user_id: userId,
    app_id: appId,
    ...otherParams,
  }

  return http()
    .post(`${prefix(appId)}/footprinter/query/multi`, params)
    .json()
}

// 批量获取用户状态
export const fetchUserStatus = (appId, { userId, ...otherParams }) => {
  return http()
    .post(`${prefix(appId)}/user/heartbeat/query`, {
      user_id: userId,
      ...otherParams,
    })
    .json()
}

// 批量获取最后上报时间
export const fetchLastInspectTime = (
  appId,
  tbId,
  { userId, ...otherParams }
) => {
  return http()
    .post(
      `${prefix(
        appId
      )}/tbs/${tbId}/elementLastOccurrence?slug=createdBy&dateSlug=createdAt`,
      {
        elements: userId,
        queryDsl: otherParams,
      }
    )
    .json()
}

// 获取用户上报统计
export const fetchInspectStatistics = (appId, tbId, params) => {
  return http()
    .post(
      `${prefix(
        appId
      )}/tbs/${tbId}/countByQueryDslAndDate?tbId=${tbId}&slugs=area&index=0`,
      params
    )
    .json()
}
